import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7cc9da54"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "notion-toolbar",
  id: "kt_toolbar"
}
const _hoisted_2 = {
  class: "notion-toolbar-inner",
  id: "kt_toolbar_container"
}
const _hoisted_3 = { class: "notion-toolbar-title" }
const _hoisted_4 = {
  key: 0,
  class: "notion-breadcrumbs"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notion-breadcrumb-sep" }, "/", -1))
const _hoisted_6 = { class: "notion-breadcrumb-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "notion-breadcrumb-sep" }, "/", -1))
const _hoisted_8 = { class: "notion-breadcrumb-current" }
const _hoisted_9 = {
  key: 1,
  class: "notion-page-heading"
}
const _hoisted_10 = { class: "notion-toolbar-actions" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["data-bs-target"]
const _hoisted_13 = {
  key: 1,
  class: "notion-toolbar-sort-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
              _createVNode(_component_router_link, {
                to: "/dashboard",
                class: "notion-breadcrumb-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Home")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item), 1)
                ], 64))
              }), 128)),
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.title), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_9, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.getAddLink && !_ctx.sortableListChanged)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_ctx.getMapping.map && !_ctx.getMapping.map.ModalForm)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { path: _ctx.getMapping.map.Actions.addLink },
                    class: "btn btn-sm btn-primary",
                    id: "kt_toolbar_primary_button"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Create ")
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.createModal && _ctx.createModal(...args))),
                    "data-bs-toggle": "modal",
                    "data-bs-target": '#kt_modal_new_card_' + _ctx.routeKey,
                    class: "btn btn-sm btn-primary",
                    id: "kt_toolbar_primary_button"
                  }, " Create ", 8, _hoisted_12))
            ]))
          : _createCommentVNode("", true),
        (_ctx.sortableListChanged)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveOrderChanged && _ctx.saveOrderChanged(...args))),
                class: "btn btn-sm btn-primary"
              }, "SAVE"),
              _createElementVNode("a", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelOrderChanged && _ctx.cancelOrderChanged(...args))),
                class: "btn btn-sm btn-light ms-2"
              }, "CANCEL")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}